import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ContentHeader from "../../components/header/contentHeader";
import { TableButton, AddButton } from "../../components/buttons";
import { Link } from "react-router-dom";
import AddServiceModal from "../../components/modals/addserviceModal";
import { Row, Col, Modal, Form, message, Button, Upload, Image, Tabs, Table } from "antd";
import { InputWrapper } from "../../components/input";
import {
  addOrUpdateData,
  addRemoveServiceFromFeatured,
  deleteDataById,
  getAllData,
} from "../../apis/generalApis";
import Column from "antd/lib/table/Column";

const StyledContent = styled.div`
  .form-label {
    text-align: left;
    margin-bottom: 8px;
    font-size: 16px;
  }
`;

const { TabPane } = Tabs;

const Services = (props) => {
  const [servicesData, setServicesData] = useState([]);

  const [regularServicesData, setRegularServicesData] = useState([]);
  const [featuredServicesData, setFeaturedServicesData] = useState([]);
  const [addServiceModal, setServiceModal] = useState(false);
  const [editServiceModal, setEditServiceModal] = useState(false);
  const [serviceForm] = Form.useForm();
  const [imageLoader, setImageLoader] = useState(false);
  const [serviceType, setServiceType] = useState("FeaturedServices");
  const [searchValue, setSearchValue] = useState("");
  const [service, setService] = useState({
    title: "",
    icon: "",
    subServices: [],
    id: "",
  });

  const handleChangeService = (e) => {
    const { name, value } = e.target;
    setService({ ...service, [name]: value });
  };
  const handleSericeForm = async () => {
    if (service.title === "") {
      message.error("Please add service name");
    } else if (typeof service.icon !== "object" && service.icon === "") {
      message.error("Please add service image");
    } else {
      let formData = new FormData();
      formData.append("name", service.title);
      formData.append("service_id", service.id);
      if (typeof service.icon !== "string") {
        formData.append("icon", service.icon);
      }
      let response = await addOrUpdateData("update-service", formData);
      if (!response) {
        message.error("Something went wrong");
      } else {
        message.success("Service updated successfully!");
        setEditServiceModal(false);
        getAllServices();
      }
    }
  };

  const handleDeleteItem = async (id) => {
    try {
      let formData = new FormData();
      formData.append("service_id", id);
      let response = await deleteDataById("delete-service", formData);
      if (response.success === true) {
        message.success("Service deleted successfully!");
        getAllServices();
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  const addRemoveServiceToFeatured = async (id, action = "") => {
    try {
      let body = {
        service_id: id,
      };
      if (action === "add") {
        let response = await addRemoveServiceFromFeatured("add-feature-service", body);
        if (response.data != null) {
          message.success("Service removed from featured successfully!");
          getAllServices();
        }
      }
      if (action === "remove") {
        let response = await addRemoveServiceFromFeatured("remove-feature-service", body);
        if (response.data != null) {
          message.success("Service removed from featured successfully!");
          getAllServices();
        }
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  useEffect(() => {
    getAllServices();
  }, []);

  const getAllServices = async () => {
    const response = await getAllData("show-services");
    if (response.length >= 0) {
      let regularServices = response.filter((service) => service.is_feature === false);
      let featuredServices = response.filter((service) => service.is_feature === true);
      setRegularServicesData(regularServices);
      setFeaturedServicesData(featuredServices);
    }
  };

  return (
    <>
      <div>
        <Modal
          title={"Edit Service Modal"}
          visible={editServiceModal}
          onCancel={() => {
            setEditServiceModal(false);
          }}
          footer={null}
          centered
        >
          <StyledContent>
            <Form
              form={serviceForm}
              id="Service"
              onFinish={handleSericeForm}
              initialValues={{ title: service.title }}
              validateTrigger="onFinish"
            >
              <Row justify="space-between">
                <Col span={11}>
                  <h4 className="form-label">*service Title</h4>
                  <Form.Item
                    name="title"
                    rules={[
                      { required: true, max: 20, message: "Service name is required" },
                    ]}
                  >
                    <p style={{ display: "none" }}>{console.log(service.title)}</p>
                    <InputWrapper
                      maxLength={20}
                      required
                      name="title"
                      value={service.title}
                      placeholder="Service Name"
                      onChange={handleChangeService}
                    />
                  </Form.Item>
                </Col>
                <Col span={11}>
                  <h4 className="form-label">*Image</h4>
                  {imageLoader == true ? (
                    <h4>Loading...</h4>
                  ) : (
                    <Image width={200} src={service.image} preview={false} />
                  )}
                  <h4 className="form-label">Edit image</h4>
                  <input
                    type="file"
                    id="files"
                    placeholder="Edit image"
                    title="choose image"
                    name="myfile"
                    onChange={async (event) => {
                      if (event.target.files[0]) {
                        setService({ ...service, image: event.target.files[0] });
                      } else {
                        setService({ ...service, image: "" });
                      }
                    }}
                  />
                </Col>
              </Row>

              <Row justify="end" align="middle" style={{ marginTop: "1rem" }}>
                <Col span={7} style={{ paddingLeft: "10px" }}>
                  <Button
                    block
                    shape="round"
                    type="danger"
                    size="default"
                    onClick={() => {
                      setEditServiceModal(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col span={7} style={{ paddingLeft: "10px" }}>
                  <Button
                    block
                    shape="round"
                    type="primary"
                    size="default"
                    style={{
                      outline: "none",
                      border: "none",
                      backgroundColor: "#49D3CE",
                    }}
                    htmlType="submit"
                  >
                    {"Ok"}
                  </Button>
                </Col>
              </Row>
            </Form>
          </StyledContent>
        </Modal>

        <AddServiceModal
          title={"Add Coupon"}
          visible={addServiceModal}
          serviceType={serviceType}
          onCancel={() => {
            setServiceModal(false);
          }}
          getAllServices={getAllServices}
        />
        <ContentHeader
          title="Services"
          // count={servicesData.length}
          value={searchValue}
          onSearch={(e) => {
            const currValue = e.target.value;
            setSearchValue(currValue);
            const filteredData = servicesData.filter((entry) =>
              entry.title.includes(currValue)
            );
            setServicesData(filteredData);
          }}
        />

        <AddButton
          onClick={() => {
            // modeRef.current = false;
            setServiceModal(true);
          }}
          style={{ float: "right", margin: "12px 0" }}
        >
          + Add New
        </AddButton>
        <Tabs
          defaultActiveKey="1"
          onChange={(event) => {
            setServiceType(event);
          }}
        >
          <TabPane tab="Featured Services" key="FeaturedServices">
            Featured Services
          </TabPane>
          <TabPane tab="Regular Services" key="RegularServices">
            Regular Services
          </TabPane>
        </Tabs>

        {serviceType == "FeaturedServices" ? (
          <Table dataSource={featuredServicesData}>
            <Column title="Name" dataIndex="name" key="index" />
            <Column
              title="Sub Services"
              dataIndex="subservices"
              key="subservices"
              render={(subservices, record) => (
                <>
                  <p>
                    {subservices?.length}
                    <Link to={`/customers/${serviceType}/${record?.id}`}>
                      <TableButton style={{ marginLeft: ".5rem" }}>View</TableButton>
                    </Link>
                  </p>
                </>
              )}
            />
            <Column
              title="Sub Services"
              render={(data) => (
                <>
                  <Button
                    type="primary"
                    style={{ marginRight: "10px" }}
                    onClick={() => {
                      setService({
                        ...service,
                        title: data.name,
                        icon: data.icon,
                        id: data.id,
                        subServices: data.subservices,
                      });
                      setEditServiceModal(true);
                    }}
                  >
                    EDIT
                  </Button>
                  <Button type="danger" onClick={() => handleDeleteItem(data?.id)}>
                    DELETE
                  </Button>
                  <Button
                    type="danger"
                    style={{ marginLeft: "10px" }}
                    onClick={() => addRemoveServiceToFeatured(data?.id, "remove")}
                  >
                    Remove from Featured Services
                  </Button>
                </>
              )}
            />
          </Table>
        ) : (
          <Table dataSource={regularServicesData}>
            <Column title="Name" dataIndex="name" key="index" />
            <Column
              title="Sub Services"
              dataIndex="subservices"
              key="subservices"
              render={(subservices, record) => (
                <>
                  <p>
                    {subservices?.length}
                    <Link to={`/customers/${serviceType}/${record?.id}`}>
                      <TableButton style={{ marginLeft: ".5rem" }}>View</TableButton>
                    </Link>
                  </p>
                </>
              )}
            />
            <Column
              title="Sub Services"
              render={(data) => (
                <>
                  <Button
                    type="primary"
                    style={{ marginRight: "10px" }}
                    onClick={() => {
                      setService({
                        ...service,
                        title: data.name,
                        icon: data.icon,
                        id: data.id,
                        subServices: data.subservices,
                      });
                      setEditServiceModal(true);
                    }}
                  >
                    EDIT
                  </Button>
                  <Button type="danger" onClick={() => handleDeleteItem(data.id)}>
                    DELETE
                  </Button>
                  <Button
                    type="primary"
                    style={{ marginLeft: "10px" }}
                    onClick={() => addRemoveServiceToFeatured(data.id, "add")}
                  >
                    Add to Featured Services
                  </Button>
                </>
              )}
            />
          </Table>
        )}
      </div>
    </>
  );
};

export default Services;

const StyledActionContent = styled.div`
  p {
    color: #1d194d;
    cursor: pointer;
    margin: 4px 0;
    :hover {
      text-decoration: underline;
      color: #393385;
    }
  }
`;
